// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SYSTEM_CHOOSE_CU_TEMPLATE,
} from './constants';

export function chooseCuTemplate(modal) {
  return {
    type: SYSTEM_CHOOSE_CU_TEMPLATE,
    data: modal,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_CHOOSE_CU_TEMPLATE:
      return {
        ...state,
        cuPositionTempListName:action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCuTemplate.js